import { render, staticRenderFns } from "./printIns.vue?vue&type=template&id=36458c27&scoped=true"
import script from "./printIns.vue?vue&type=script&lang=js"
export * from "./printIns.vue?vue&type=script&lang=js"
import style0 from "./printIns.vue?vue&type=style&index=0&id=36458c27&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36458c27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36458c27')) {
      api.createRecord('36458c27', component.options)
    } else {
      api.reload('36458c27', component.options)
    }
    module.hot.accept("./printIns.vue?vue&type=template&id=36458c27&scoped=true", function () {
      api.rerender('36458c27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/printIns.vue"
export default component.exports